import dom from "../../../../../../dist/jsx-render/dom";
import { app } from "../../../../../Frame/App";
import { MeasureEditFactory } from "../../../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType } from "../../../../PagePopup";
import { MeasureTextProvider } from "../MeasureTextProvider";

export class SiemensEnergy {

    public static createCwDropdown(element: HTMLElement) {
        let ulElements = element.querySelectorAll("[data-cw-dropdown]");

        ulElements.forEach(e => {

            let ulElement = e as HTMLElement;
            let internalName = ulElement.getAttribute("data-internal-name");
            let templateId = ulElement.getAttribute("data-template-id");

            if (internalName && internalName.length > 0 && templateId && templateId.length > 0) {
                let measureId = parseInt(app.getParameterByName("parentId"));
                $.ajax({
                    url: app.resolveUrl(`~/api/siemensEnergy/getCwList/${measureId}/${internalName}/${templateId}`),
                    method: "GET",
                    success: (response) => {
                        ulElement.innerHTML = "";
                        let responseItems = response as any[];
                        if (responseItems && responseItems.length > 0) {
                            ulElement.classList.add("dropdown");
                            ulElement.id = app.createGuid();

                            ulElement.appendChild(<a className="dropdown-toggle text-white text-decoration-none" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">{responseItems[0].name}</a>);

                            let menu: HTMLElement = <div className="dropdown-menu"></div>;
                            ulElement.appendChild(menu);

                            for (let item of responseItems) {
                                let menuItem: HTMLElement = <a className="dropdown-item" href="#" data-id={item.id} data-element-id={ulElement.id}>{item.name}</a>;
                                menuItem.addEventListener("click", SiemensEnergy.onCwClicked);
                                menu.appendChild(menuItem);
                            }

                            SiemensEnergy.updateCwButtons(ulElement, responseItems[0].id);

                            SiemensEnergy.loadCwContent(responseItems[0].id);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });
            }
        });
    }

    static onCwClicked(ev: Event) {
        let id = parseInt((ev.currentTarget as HTMLElement).getAttribute("data-id"));
        let text = (ev.currentTarget as HTMLElement).innerText;
        let elementId = (ev.currentTarget as HTMLElement).getAttribute("data-element-id");

        let element = document.getElementById(elementId);
        let toggle = element.querySelector(".dropdown-toggle") as HTMLElement;
        toggle.innerText = text;

        SiemensEnergy.updateCwButtons(element, id);
        SiemensEnergy.loadCwContent(id);
    }

    static updateCwButtons(element: HTMLElement, id: number) {
        // button edit
        let editButton = element.parentElement.querySelector("[data-cw-edit]");
        if (editButton) {
            editButton.setAttribute("data-id", id.toString());
        }
    }

    public static createCwEditButton(element: HTMLElement) {
        let ulElements = element.querySelectorAll("[data-cw-edit]");
        ulElements.forEach(e => {
            e.addEventListener("click", SiemensEnergy.onCwEditClicked);
        });
    }

    public static createCwAddButton(element: HTMLElement) {
        let ulElements = element.querySelectorAll("[data-cw-add]");
        ulElements.forEach(e => {
            e.addEventListener("click", SiemensEnergy.onCwAddClicked);
        });
    }

    static onCwEditClicked(ev: Event) {
        let element = ev.currentTarget as HTMLElement;
        let idString = element.getAttribute("data-id");
        if (idString && idString.length > 0) {
            MeasureEditFactory.showMeasure({
                measureId: parseInt(idString),
                templateId: 0,
                parentId: 0,
                parentGuid: "00000000-0000-0000-0000-000000000000",
                fullScreen: false,
                additionalAction: "hideLeftPart",
                onClose: ((reason: PopupCloseType, id: number) => {
                    if (reason == "delete") {
                        SiemensEnergy.createCwDropdown(element.parentElement);
                    }
                    else {
                        SiemensEnergy.loadCwContent(id);
                    }
                })
            });
        }
    }

    static onCwAddClicked(ev: Event) {
        let element = ev.currentTarget as HTMLElement;
        let templateIdString = element.getAttribute("data-template-id");
        let parentId = parseInt(app.getParameterByName("parentId"));
        MeasureEditFactory.showMeasure({
            measureId: 0,
            templateId: parseInt(templateIdString),
            parentId: parentId,
            parentGuid: "00000000-0000-0000-0000-000000000000",
            fullScreen: false,
            additionalAction: "hideLeftPart",
            onClose: ((reason: PopupCloseType, id: number) => {
                SiemensEnergy.createCwDropdown(element.parentElement);
            })
        });
    }

    static loadCwContent(id: number) {
        let fields: string[] = [];
        let ulElements = document.querySelectorAll("[data-cw-content]");
        ulElements.forEach(e => {
            let field = e.getAttribute("data-field");
            if (field && field.length > 0) {
                fields.push(field);
            }
        });

        $.ajax({
            url: app.resolveUrl(`~/api/measure/getMeasureValues/${id}`),
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(fields),
            success: (response: { [id: string]: string }) => {
                ulElements.forEach(e => {
                    let field = e.getAttribute("data-field");
                    let isAmpel = e.getAttribute("data-is-ampel") == "true";
                    if (field && field.length > 0) {
                        if (isAmpel) {
                            let ampel = 2;
                            if (response[field] && response[field].length > 0) {
                                ampel = parseInt(response[field]);
                            }

                            e.classList.remove("ampel-red");
                            e.classList.remove("ampel-yellow");
                            e.classList.remove("ampel-blue");
                            e.classList.remove("ampel-green");

                           switch (ampel) {
                               case 0:
                                   e.classList.add("ampel-red");
                                   break;
                                case 1:
                                   e.classList.add("ampel-yellow");
                                   break;
                                case 2:
                                   e.classList.add("ampel-blue");
                                   break;
                                case 3:
                                   e.classList.add("ampel-green");
                                   break;
                            }
                        }
                        else {
                            if (response[field]) {
                                e.innerHTML = MeasureTextProvider.convertLineBreaks(response[field])
                            }
                            else {
                                e.innerHTML = "";
                            }
                        }
                    }
                });
            },
            error: (err) => {
                console.log(err);
            }
        });
    }
}